import ConfirmByPhone from './ConfirmByPhone';
import './style.styl';

export { ConfirmByPhone };
export default ConfirmByPhone;
